import React from "react";
import PropTypes from "prop-types";
import { StepDescriptionWrapper } from "../../../styles";

export const ContributionTypeStep = props => {
  const data = props.data;
  let assetHeld = (data.assetHeldatVG.mfSelected === true || data.assetHeldatVG.sgSelected) ? 'Asset held at Vanguard, ' : '';
  let assetOut = (data.assetOutsideVG.mfSelected === true || data.assetOutsideVG.sgSelected) ? 'Asset held Outside Vanguard, ' : '';
  let check = (data.checkOrEBT.checkSelected === true) ? 'Check or EBT, ' : '';
  let wire = (data.wire.wireSelected === true) ? 'Wire, ' : '';
  let stock = (data.stockCertificate.stockSelected === true) ? 'Stock Certificate' : '';
  let typeSelected = assetHeld + assetOut + check + wire + stock;
  return (
    <div data-test="wrapper">
      <StepDescriptionWrapper>{typeSelected.replace(/,\s*$/, "")}</StepDescriptionWrapper>
    </div>
  );
};

ContributionTypeStep.propTypes = {
data: PropTypes.object
}